import React from 'react';
import {Button, IconButton, Snackbar} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';
import {connect} from "react-redux";
import Auction from "../components/Auction";
import {clearError} from "../actions";

const styles = theme => ({
    close: {
        padding: theme.spacing.unit / 2,
    },
})

class InfoMessage extends React.Component {

    render() {
        const props = this.props;
        const { classes } = props;
        return  (
            <span>
                <Snackbar
                    open={props.open}
                    message={props.message}
                    autoHideDuration={props.duration || 5000}
                    onClose={props.onInfoClose}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            className={classes.close}
                            onClick={props.onInfoClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    ]}

                />
            </span>
        );
    }
}

InfoMessage.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    message: PropTypes.string,
    duration: PropTypes.number,
    onInfoClose: PropTypes.func
}


function mapStateToProps(state, ownProps) {
    return {
        open: (state.pbnRequest.error !== ''),
        message: state.pbnRequest.error,
        duration: 5000
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onInfoClose: function () {
            dispatch(clearError())
        }
    };
}

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(InfoMessage)
)